import FilterCheckbox from "../FilterSection/shared/FilterCheckbox";
import { cn } from "@/lib/utils";
import { useTracksControllerTracksListMoods } from "@/lib/lutely-api/gen/tracks/tracks";

type MobileMoodsFilterProps = {
  value: string[];
  onChange: (next: string[]) => void;
};

export default function MobileMoodsFilter({
  value,
  onChange,
}: MobileMoodsFilterProps) {
  const { data: moods = [] } = useTracksControllerTracksListMoods();

  const toggleMood = (moodId: string) => {
    if (value.includes(moodId)) {
      onChange(value.filter((item) => item !== moodId));
    } else {
      onChange([...value, moodId]);
    }
  };

  return (
    <div className="grid grid-cols-2 gap-2">
      {moods.map((mood) => {
        const isSelected = value.includes(mood.classificationId);
        return (
          <button
            key={mood.classificationId}
            type="button"
            onClick={() => toggleMood(mood.classificationId)}
            className={cn(
              "flex items-center gap-2 rounded-xl px-3 py-2 bg-white/0 hover:bg-white/10 transition-colors",
              isSelected && "bg-white/10",
            )}
          >
            <FilterCheckbox checked={isSelected} />
            <span className="text-left text-[14px] font-medium">
              {mood.name}
            </span>
          </button>
        );
      })}
    </div>
  );
}
